import { AfterContentInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild, inject } from '@angular/core';
import { MapService as MapLibreMapService } from '@maplibre/ngx-maplibre-gl';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { SearchControl } from './search-control';
import { IonRouterOutlet, ModalController, IonicModule } from '@ionic/angular';
import { POIPage, POISearchModalResult } from '../../poi-page/poi.page';
import { CustomMapGeoJSONFeature } from '../../map.component';

@Component({
    selector: 'app-map-control-search',
    template: `
    <div class="maplibregl-ctrl maplibregl-ctrl-group search" #content>
      <button (click)="search()" [attr.aria-label]="'map.search.buttonLabel' | translate">
        <ion-icon name="search" size="large"></ion-icon>
      </button>
    </div>
  `,
    styleUrls: ['./search.component.scss'],
    imports: [IonicModule, TranslatePipe]
})
export class SearchControlComponent implements AfterContentInit, OnDestroy {
  private mapLibreMapService = inject(MapLibreMapService);
  private modalController = inject(ModalController);
  private routerOutlet = inject(IonRouterOutlet);
  translate = inject(TranslateService);

  @Input()
  public features: GeoJSON.Feature[] = [];

  @Input() 
  public position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

  @Output()
  public selectedFeature = new EventEmitter<CustomMapGeoJSONFeature>();

  @ViewChild('content', { static: true }) content: ElementRef;

  private control: SearchControl;
  private searchQuery?: string;

  ngAfterContentInit() {
    if (this.content.nativeElement.childNodes.length) {
      this.control = new SearchControl(this.content.nativeElement);

      this.mapLibreMapService.mapCreated$.subscribe(() => {
        this.mapLibreMapService.addControl(this.control, this.position);
      });
    }
  }

  ngOnDestroy() {
    if (this.mapLibreMapService.mapInstance.hasControl(this.control)) {
      this.mapLibreMapService.removeControl(this.control);
    }
  }

  public async search() {
    const modal = await this.modalController.create({
      component: POIPage,
      componentProps: {
        isModal: true,
        features: this.features,
        searchQuery: this.searchQuery
      },
      canDismiss: true,
      presentingElement: this.routerOutlet.nativeEl
    });
    modal.present();

    const { data } = await modal.onDidDismiss<POISearchModalResult>();

    if (data) {
      this.searchQuery = data.searchQuery;
    }

    if(data?.feature) {
      const feature = data.feature.properties as CustomMapGeoJSONFeature;
      this.selectedFeature.emit(feature);
    }
  }
}
